
import { takeLatest, put, call } from 'redux-saga/effects';
import {
    FETCH_RISKFACTOR_DETAILS,
    fetchRiskFactorDetailsSuccess,
    fetchRiskFactorDetailsFailure,
    DOWNLOAD_RISKFACTOR_DETAILS,
    UPLOAD_RISKFACTOR_DETAILS

} from './action'
import {
    downloadRiskfactorTemplateSuccess, downloadRiskfactorTemplateFailure,
    uploadRiskfactorTemplateSuccess, uploadRiskfactorTemplateFailure
} from '../Search/action';
import { SCORE_DEFINATION } from '../../../config';
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../../constants';
import request from '../../../components/Utils/httpHelper';

export function* riskFactorDetails(action) {
    let requestUrl = `${SCORE_DEFINATION}/riskfactor/fetch/${action.data}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(fetchRiskFactorDetailsSuccess(result.data));
    } catch (err) {
        yield put(fetchRiskFactorDetailsFailure(err))
    }
}
export function* fetchRiskFactorDetails() {
    yield takeLatest(FETCH_RISKFACTOR_DETAILS, riskFactorDetails);
}

export function* downloadRiskFactor(action) {
    let requestUrl = `${SCORE_DEFINATION}/riskfactor/download/${action.data}`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(downloadRiskfactorTemplateSuccess(result));
    } catch (err) {
        yield put(downloadRiskfactorTemplateFailure(err))
    }
}
export function* donwloadRiskFactorDetails() {
    yield takeLatest(DOWNLOAD_RISKFACTOR_DETAILS, downloadRiskFactor);
}

export function* editRiskFactorTemplate(action) {
    let requestUrl = `${SCORE_DEFINATION}/riskfactor/edit/${action.data.id}`;
    const formData = new FormData();
    formData.append('file', action.data.file);
    try {
        const result = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(uploadRiskfactorTemplateSuccess(result.data));
    } catch (err) {
        yield put(uploadRiskfactorTemplateFailure(err))
    }
}
export function* uploadRiskFactorDetails() {
    yield takeLatest(UPLOAD_RISKFACTOR_DETAILS, editRiskFactorTemplate);
}